import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import Grid from './Grid'

export function getItems (components = [], componentItems = [], repeatIndex = 0, items = [], max = 10, Component, LayoutEditor) {
  if (isNaN(repeatIndex) || repeatIndex < 0) repeatIndex = 0
  if (repeatIndex > components.length - 1) repeatIndex = components.length - 1
  let repeatComponent = componentItems[repeatIndex]
  items = items.slice()

  let repeatItems = components && components.reduce((arr, item, i) => {
    if (i === repeatIndex) {
      if (LayoutEditor) {
        arr.push(<LayoutEditor item={repeatComponent} renderProps={{ item: items[0] }} key={i} />)
        items.shift()
      }
      arr = arr.concat(items.slice(0, max).map((item2, j) => {
        return <Component component={repeatComponent} index={j} item={item2} key={`repeat-${j}`} />
      }))
    } else {
      if (LayoutEditor) {
        arr.push(<LayoutEditor item={item} key={i} />)
      } else {
        let Component = item
        arr.push(<Component key={i} />)
      }
    }

    return arr
  }, [])
  return repeatItems
}

const Repeater = observer(class Repeater extends React.Component {
  static propTypes = {
    /**
     * List of items to be iterated
     */
    items: PropTypes.array,

    /**
     * Gap between the items
     */
    gap: PropTypes.string,

    /**
     * Height of an item
     */
    height: PropTypes.number,

    /**
     * Number of columns
     */
    columns: PropTypes.number,

    /**
     * Maximum numbers of items to be displayed
     */
    maxItems: PropTypes.number,

    /**
     * Designates which component - one level down - in the repeater that should be repeated. If left blank, it takes the first item. For example: if you have one container in the repeater, and leave the repeateIndex blank, this item will be repeated. If you have 1 label (for example a header in the repeater), and 1 container, and set the repeatIndex to 2, the label will be ignored, and the container will be repeated (as it has index #2)
     */
    repeatIndex: PropTypes.number,
    children: PropTypes.node
  }

  gridRef = React.createRef()

  state = {
    hasChildren: false
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (
      !this.state.hasChildren &&
      this.gridRef.current &&
      this.gridRef.current.props &&
      this.gridRef.current.props.children &&
      !!this.gridRef.current.props.children.length
    ) {
      this.setHasChildren()
    }
  }

  setHasChildren = () => {
    this.setState({
      hasChildren: true
    })
  }

  render () {
    let { repeatIndex, maxItems = 10, items = [], childrenComponents, componentItems } = this.props
    return (
      <div>
        <Grid {...this.props} ref={this.gridRef}>
          {getItems(
            childrenComponents,
            componentItems,
            repeatIndex,
            items,
            maxItems,
            this.props.ctx && this.props.ctx.Component
          )}
        </Grid>
        <style jsx>{`
          div :global(div[data-component="Container"].GridItem) {
            height: 100%;
          }
        `}</style>
      </div>
    )
  }
})

export default Repeater
